document.addEventListener('DOMContentLoaded', function () {
  // AJAX add-to-cart for product-card forms, so the page doesn't reload
  document.querySelectorAll('.product-card form, .product-page form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var button = form.querySelector('button[type="submit"]');
      var originalText = button ? button.textContent : '';

      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var countEl = document.querySelector('.site-header__cart-count');
          if (countEl) countEl.textContent = cart.item_count;
          if (button) button.textContent = 'Added ✓';
        })
        .catch(function () {
          if (button) button.textContent = 'Error';
        })
        .finally(function () {
          setTimeout(function () {
            if (button) {
              button.disabled = false;
              button.textContent = originalText;
            }
          }, 1500);
        });
    });
  });
});
